import { createSlice } from "@reduxjs/toolkit";

export const carrierFiltersSlice = createSlice({
    name: 'carrierFilters',
    initialState: {
        searchVal: ''
    },
    reducers: {
        setSearchVal: (state, action) => {
            state.searchVal = action.payload;
        }
    },
});

export const { setSearchVal } = carrierFiltersSlice.actions;
export default carrierFiltersSlice.reducer;